<app-complex-modal-template
    class="flex flex-col"
    [canConfirm]="formGroup?.valid ?? false"
    [title]="'dataExportConfiguration' | transloco"
    (onClickEvent)="closeModal($event)">
    <app-export-modal-simple-options [formGroup]="formGroup!" />
    <app-button
        iconSize="xs"
        [icon]="['fas', !isAdvancedOptionsOpen() ? 'chevron-up' : 'chevron-down']"
        [iconPosition]="IconPosition.END"
        [label]="'advancedOptions' | transloco"
        [type]="ButtonType.UNDERLINE"
        (onClick)="isAdvancedOptionsOpen.set(!isAdvancedOptionsOpen())" />
    <app-export-modal-advanced-options
        [formGroup]="formGroup!"
        [isAdvancedOptionsOpen]="isAdvancedOptionsOpen()" />
</app-complex-modal-template>
